import React from "react";
import { useState, useEffect } from "react";
import Logo from '../assets/logo.svg'
import M from 'materialize-css';
import {
    setUser, setToken, setIdToken, loadUser, setLegales, toogleLoad,
    setTokenSesion, setCoordenadas
} from "../redux/slices/appslice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { encryptAES, getCoordenadas } from "../utils";
import { BASE_URL } from "../properties";
import Terminos from '../components/terminos';
import { getLegales, setBitacora, getDatosInactividad, getContactoConfig, guardarAccionBitacora } from '../firestore';
import Token from "../components/token";
import { solicitaCodigoLogin, validaCodigoLogin, cerrarSesion } from '../ws';
import { useAnalytics } from '../AnalyticsContext'
import { logEvent } from "firebase/analytics";



function Login() {

    const analytics = useAnalytics();
    const appData = useSelector((state) => state.appData)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const locationrr = useLocation();
    const params = useParams();
    const [loginData, setLogginData] = useState({ usuario: "", password: "", errorlogin: false })
    const [muestraToken, setMuestraToken] = useState(false);
    const [errorToken, setErrorToken] = useState(false);
    const [sesionActiva, setSesionActiva] = useState(false);
    const [toogleEye, setToogleEye] = useState(false)
    const [loading, setLoading] = useState(false)
    const [timeInactividad, setDataInactividad] = useState(false);
    const [configContacto, setConfigContacto] = useState(false);

    useEffect(() => {

        dispatch(loadUser())
        legalesF();
        dataInactividad();
        initCoordenadas();
        M.updateTextFields();

        if (window.navigator.userAgent.indexOf("Edg") > -1) {
            let ojos = document.getElementsByClassName('field-icon');

            if (ojos.length) {
                for (let ojo of ojos) {
                    ojo.style.display = 'none';
                }
            }

        }

        setTimeout(() => {
            const usr = document.getElementById('lblUsr');
            const pass = document.getElementById('lblPass');
            if (usr) usr.classList.add('active');
            if (pass) pass.classList.add('active');
        }, 500)
        M.Modal.init(document.getElementById('modalSesion'), {
            dismissible: false,
            onOpenEnd: () => {

                logEvent(analytics, "Login_verificar_correo", {
                    screen_name: "Login",
                });
            }
        });

        getContactoConf();
       

    }, []);

    const getContactoConf = async () => {
      
        const configContacto = await getContactoConfig();

        setConfigContacto(configContacto);

    }



    useEffect(() => {
        M.updateTextFields();
    }, [loginData])

    const legalesF = async () => {
        let legales = await getLegales();
        M.Modal.init(document.querySelectorAll('.modal'), {
            onCloseStart: (e) => {


                if (e.id === 'modalSesion') {
                    setMuestraToken(false);
                }
            }
        });
        dispatch(setLegales(legales));
    }

    const dataInactividad = async () => {

        let dataIN = await getDatosInactividad();

        setDataInactividad(dataIN);
    }

    const passTemporal = async () => {
        setLoading(true);
        if (loginData.usuario.trim() !== "") {
            let dataToEncrypt = {
                "Usuario": loginData.usuario,
                "DeviceToken": "",
                "SistemaOperativo": "",
                "AppID": ""
            }

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ DatosEncriptados: encryptAES(dataToEncrypt) })
            };

            fetch(`${BASE_URL}/loggin/EnvioContraseniaTemporal`, requestOptions)
                .then(response => response.json())
                .then((data) => {
                    setLoading(false);
                    if (data && data.BanderaExito) {
                        guardarAccionBitacora("EnvioContrasenaTemporal", "Se envió la contraseña temporal exitosamente", "SUCCESS", loginData.usuario);

                        let mInstance = M.Modal.getInstance(document.getElementById('pass_temporal'));
                        mInstance.open();

                    } else {
                        guardarAccionBitacora("EnvioContrasenaTemporal", "Fallo al enviar contraseña temporal: " + (data.Mensaje ? data.Mensaje : "Error desconocido"), "ERROR", loginData.usuario);
                        if (data && data.Mensaje && data.Mensaje.trim() !== "") {
                            setLogginData({ ...loginData, errorlogin: data.Mensaje.trim() })
                        }
                    }
                }).catch((e) => {
                    guardarAccionBitacora("EnvioContrasenaTemporal", "Fallo al enviar contraseña temporal por error de red", "ERROR", loginData.usuario);
                    setLoading(false);
                });
        } else {
            setLoading(false);
            setLogginData({ ...loginData, errorlogin: 'Ingresa tu usuario' })
        }

    }

    async function initCoordenadas() {
        try {

            let coordenadas = await getCoordenadas();
            if (coordenadas) {
                dispatch(setCoordenadas(coordenadas))
            }
        } catch (error) {

        }
    }

    async function submitLogin(e) {
        debugger;
        logEvent(analytics, "Login_inicio_sesión", {
            screen_name: "Login",
        });

        dispatch(toogleLoad(true));
        if (e) {
            e.preventDefault()
        }

        guardarAccionBitacora("IntentoLogin", "Inicio de proceso de login", "INFO", loginData.usuario);

        let coordenadas = appData.coordenadas;

        try {
            if (!coordenadas) {
                coordenadas = await getCoordenadas();
                if (coordenadas) {
                    dispatch(setCoordenadas(coordenadas))
                } else {
                    coordenadas = { latitude: "", longitude: "", direccion: "", navegador: "" };
                    dispatch(setCoordenadas(coordenadas));
                }
            }
        } catch (error) {
            coordenadas = { latitude: "", longitude: "", direccion: "", navegador: "" };
            dispatch(setCoordenadas(coordenadas));
        }

        if (coordenadas) {

            let dataToEncrypt = {
                "Usuario": loginData.usuario,
                "Contrasenia": loginData.password,
                "DeviceToken": "",
                "SistemaOperativo": "",
                "AppID": ""
            }

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ DatosEncriptados: encryptAES(dataToEncrypt) })
            };

            fetch(`${BASE_URL}/loggin/ValidaUsuario`, requestOptions)
                .then(response => response.json())
                .then((data) => {

                    if (data.Datos && data.JWT && data.firebase && data.firebase.idToken) {



                        let usuario = JSON.parse(JSON.stringify(data.Datos));

                        usuario.usuarioLogin = loginData.usuario;
                        usuario.timeInactividad = timeInactividad;

                        dispatch(setUser(usuario))
                        dispatch(setToken(data.JWT))
                        dispatch(setIdToken(data.firebase.idToken))
                        dispatch(setTokenSesion(data.JWT.access_token))

                        setBitacora({
                            data: {
                                fecha: Date.now(),
                                ip: appData.ip,
                                latitude: coordenadas?.latitude || "",
                                longitud: coordenadas?.longitude || "",
                                lugar: coordenadas?.direccion || "",
                                navegador: coordenadas?.navegador || ""
                            },
                            idUsuario: data.Datos.IdUsuario
                        })

                        guardarAccionBitacora("LoginExitoso", "El usuario inició sesión exitosamente", "SUCCESS", loginData.usuario);

                        dispatch(toogleLoad(false));

                        navigate('/')
                    } else {
                        dispatch(toogleLoad(false));
                        
                        guardarAccionBitacora("LoginFallido", "Fallo al iniciar sesión: " + (data.IdError ? ("Error " + data.IdError) : "Desconocido"), "ERROR", loginData.usuario);

                        if (data.IdError && data.IdError === 76) {

                            setSesionActiva({
                                idUsuario: data.Mensaje.idUsuario,
                                sesion: data.Mensaje.sesion,
                                token: data.JWT.access_token,
                                refreshToken: data.JWT.refresh_token,
                                idToken: data.firebase.idToken,
                                JWT: data.JWT
                            });

                            let instance = M.Modal.getInstance(document.getElementById('modalSesion'));
                            if (instance) {
                                instance.open();
                            }
                        } else if (data.IdError && (data.IdError === 74 || data.IdError === 16)) {
                            setLogginData({ ...loginData, errorlogin: "No fue posible iniciar sesión, por seguridad es necesario comunicarse a Valmex." })
                        } else {
                            if (data.Mensaje) {
                                if (data.Mensaje && data.Mensaje.mensaje) {
                                    setLogginData({ ...loginData, errorlogin: data.Mensaje.mensaje })
                                } else if (data.Mensaje && typeof data.Mensaje == 'string') {
                                    setLogginData({ ...loginData, errorlogin: data.Mensaje })
                                }

                            } else {
                                setLogginData({ ...loginData, errorlogin: "No logró iniciar sesión intente nuevamente." })
                            }
                        }


                    }
                }).catch((e) => {

                    dispatch(toogleLoad(false));

                });
        } else {
            dispatch(toogleLoad(false));
        }
    }

    async function solCodigoLogin() {
        try {
            dispatch(toogleLoad(true));
            let result = await solicitaCodigoLogin(sesionActiva);
            if (result && result.BanderaExito) {
                setMuestraToken(true);
            }
            dispatch(toogleLoad(false));
        } catch (error) {
            dispatch(toogleLoad(false));
        }
    }

    async function validaCodigoL(token) {
        try {
            dispatch(toogleLoad(true));
            let dataSend = JSON.parse(JSON.stringify(sesionActiva));
            dataSend.CodigoSeg = token;
            let result = await validaCodigoLogin(dataSend);
            if (result && result.BanderaExito) {

                let resultCierra = await cerrarSesion({
                    user: {
                        usuarioLogin: loginData.usuario,
                        IdUsuario: sesionActiva.idUsuario,
                        Sesion: sesionActiva.sesion,

                    },
                    tokenSesion: result.JWT.current_token, //sesionActiva.idToken,
                    token: {
                        refresh_token: sesionActiva.refreshToken
                    },
                    authorizacion: sesionActiva.idToken,
                    codigoSeg: dataSend.CodigoSeg,
                    password: loginData.password

                });
                if (resultCierra && resultCierra.BanderaExito) {
                    dispatch(toogleLoad(false));
                    M.Modal.getInstance(document.getElementById('modalSesion')).close();
                    await submitLogin();
                }
            } else {
                setErrorToken('Token Incorrecto')
            }
            dispatch(toogleLoad(false));
        } catch (error) {
            dispatch(toogleLoad(false));
        }
    }

    function fToogleEye() {
        setToogleEye(!toogleEye)
    }

    return (
        <React.Fragment>
            <div className="loginModule">
                <div className="bannerContent"></div>
                <div className="loginMainWrapper">
                    <div className="loginColumnsContainer">
                        {/* Columna Izquierda: Tarjeta Blanca de Login */}
                        <div className="loginCard">
                            <form onSubmit={async (e) => {
                                await submitLogin(e);
                            }}>
                                <div className="loginLogoContainer">
                                    <img src={Logo} alt="logo" className="loginLogoImg" />
                                </div>
                                <div className="loginTitleContainer">
                                    <span className="loginTitleText">¡Bienvenido!</span>
                                </div>

                                <div className="loginInputGroup">
                                    <div className={`loginInputBox ${loginData.errorlogin ? 'inputError' : ''}`}>
                                        <input
                                            id="user"
                                            type="text"
                                            placeholder="Usuario"
                                            value={loginData.usuario}
                                            onChange={(e) => {
                                                setLogginData({ ...loginData, usuario: e.target.value, errorlogin: false });
                                            }}
                                            className="loginInputField"
                                            autoComplete="username"
                                        />
                                    </div>
                                    {loginData.errorlogin ? (
                                        <span className="loginHelperText">{loginData.errorlogin}</span>
                                    ) : null}
                                </div>

                                <div className="loginInputGroup">
                                    <div className={`loginInputBox ${loginData.errorlogin ? 'inputError' : ''}`}>
                                        <input
                                            type={toogleEye ? 'text' : 'password'}
                                            name="password"
                                            id="password"
                                            placeholder="Contraseña"
                                            value={loginData.password}
                                            onChange={(e) => {
                                                setLogginData({ ...loginData, password: e.target.value, errorlogin: false });
                                            }}
                                            className="loginInputField"
                                            autoComplete="current-password"
                                        />
                                        <span onClick={fToogleEye} className="loginEyeIcon field-icon">
                                            <span className="material-icons">
                                                {toogleEye ? 'visibility_off' : 'visibility'}
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                <div className="loginForgotContainer">
                                    <span
                                        className="loginForgotLink cursorPointer"
                                        onClick={async () => {
                                            logEvent(analytics, "Login_olvide_contraseña", {
                                                screen_name: "Login",
                                            });
                                            await passTemporal();
                                        }}
                                    >
                                        Olvidé mi contraseña
                                    </span>
                                </div>

                                <div className="loginButtonContainer">
                                    <button
                                        id="btnLogin"
                                        disabled={
                                            loginData.usuario.trim().length === 0 ||
                                            loginData.password.trim().length === 0 ||
                                            loading
                                        }
                                        type="submit"
                                        className={`loginSubmitBtn ${
                                            loginData.usuario.trim().length === 0 ||
                                            loginData.password.trim().length === 0 ||
                                            loading
                                                ? 'btnDisabled'
                                                : 'btnActive'
                                        }`}
                                    >
                                        Iniciar sesión
                                    </button>
                                </div>

                                <div className="loginTermsContainer">
                                    <span
                                        className="loginTermsLink modal-trigger cursorPointer"
                                        href="#aviso_privacidad"
                                        onClick={() => {
                                            logEvent(analytics, "Login_terminos_condiciones", {
                                                screen_name: "Login",
                                            });
                                        }}
                                    >
                                        Ver términos y condiciones
                                    </span>
                                </div>
                            </form>
                        </div>

                        {/* Columna Derecha: Botones de acceso rápido y contacto */}
                        <div className="loginSidePanel">
                            <div className="loginQuickLinks">
                                <button
                                    type="button"
                                    className="loginPillBtn"
                                    onClick={() => {
                                        logEvent(analytics, "Preguntas_Frecuentes", {
                                            screen_name: "Hamburguesa",
                                        });
                                        navigate('/faqs');
                                    }}
                                >
                                    Preguntas Frecuentes
                                </button>

                                <button
                                    type="button"
                                    className="loginPillBtn"
                                    onClick={() => {
                                        navigate('/educacion_financiera');
                                    }}
                                >
                                    Educación Financiera
                                </button>

                                <button
                                    type="button"
                                    className="loginPillBtn"
                                    onClick={() => {
                                        navigate('/calcular_retiro');
                                    }}
                                >
                                    Calcula tu Pensión
                                </button>

                                <button
                                    type="button"
                                    className="loginPillBtn"
                                    onClick={() => {
                                        const elem = document.getElementById('seccionContacto');
                                        if (elem) elem.scrollIntoView({ behavior: 'smooth' });
                                    }}
                                >
                                    Contacto
                                </button>

                                <button
                                    type="button"
                                    className="loginPillBtn"
                                    onClick={() => {
                                        navigate('/conocenos');
                                    }}
                                >
                                    Conócenos
                                </button>

                                <button
                                    type="button"
                                    className="loginPillBtn"
                                    onClick={() => {
                                        navigate('/educacion_financiera');
                                    }}
                                >
                                    Educación Financiera
                                </button>
                            </div>

                            <div className="loginContactSection" id="seccionContacto">
                                <h3 className="loginContactTitle">Contacto</h3>
                                <p className="loginContactSchedule">
                                    {configContacto && configContacto.leyendaHorario
                                        ? configContacto.leyendaHorario
                                        : 'Los horarios de atención son de Lunes a Viernes de 9:00 a 17:00 hrs. Puedes contactarnos:'}
                                </p>

                                <div className="loginContactCard">
                                    <h4 className="loginContactOrg">Valmex</h4>
                                    <a
                                        href={`tel:+52${configContacto?.telefono || '8000082563'}`}
                                        className="loginContactTel"
                                    >
                                        {configContacto?.telefonotext || '800 0082 563'}
                                    </a>
                                    <a
                                        href={`mailto:${configContacto?.email || 'solucionesempleados@valmex.mx'}`}
                                        className="loginContactEmail"
                                        onClick={() => {
                                            logEvent(analytics, "contacto_correo_vmxsi", {
                                                screen_name: "Hamburguesa",
                                            });
                                        }}
                                    >
                                        {configContacto?.email || 'solucionesempleados@valmex.mx'}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="aviso_privacidad" className="modal">
                    <div className="modal-content">
                        <Terminos centerTitle={true} />
                    </div>
                    <div className="modal-footer">
                        <a href="#!" className="modal-close waves-effect waves-green btn-flat vlmx-navy-80 No_txtDeco">Aceptar</a>
                    </div>
                </div>

                <div id="pass_temporal" className="modal">
                    <div className="modal-content">
                        <div className="row">
                            <div className="col s12 mt-2 center-align">
                                <img src={Logo} alt="logo" />
                            </div>
                            <div className="col s12 mt-2 center-align">
                                <span className="ft-24 boldText">¡Te enviaremos tu contraseña temporal!</span>
                            </div>
                            <div className="col s12 mt-2 center-align">
                                <span className="ft-16 fw-300"> Se enviará una contraseña a tu correo electrónico o celular registrado</span>
                            </div>
                            <div className="col s12 mt-2 center-align">
                                <button type="button" className="btn btn-webSi-primary waves-effect light modal-close"
                                    style={{ width: '328px !important' }}
                                >Aceptar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modalSesion" className="modal">
                <div className="modal-content">
                    <div className="row">
                        <div className="col s12 right-align">
                            <i className="material-icons cursorPointer modal-close" >close</i>
                        </div>
                    </div>
                    {
                        muestraToken ?
                            <div className="row">
                                <div className="col s12 center-align mt-1">

                                    <img src={Logo} alt="logo" />

                                </div>
                                <div className="col s12 center-align txtBold mt-2">

                                    Por último
                                </div>

                                <div className="col s12 center-align mt-1">
                                    Ingresa el código que se te envió a tu correo electrónico
                                </div>
                                <div className="col s12 left-align mt-1 red-text">
                                    {errorToken ? errorToken : null}
                                </div>
                                <div className="col s12 center-align mt-1">
                                    <Token callBack={validaCodigoL} />
                                </div>
                                <div className="col s12 center-align mt-1">
                                    <span className="ft-12 cursorPointer" onClick={() => {
                                        solCodigoLogin()
                                    }
                                    }>Solicitar otro código</span>
                                </div>


                            </div>

                            :

                            <div className="row">
                                <div className="col s12 mt-1 left-align txtBold ft-16">
                                    Error de sesión
                                </div>
                                <div className="col s12 mt-1 ft-14 txtBold">
                                    Tu usuario cuenta con una sesión activa,
                                    ¿Deseas cerrar la sesión activa?
                                </div>
                                <div className="col s12 mt-1 right-align">
                                    <button className="btn-flat"
                                        onClick={async () => {
                                            solCodigoLogin();
                                        }}
                                    ><span className="primaryText txtBold">Sí</span></button> <button className="modal-close btn-flat"><span className="primaryText txtBold">No</span></button>
                                </div>
                            </div>
                    }

                </div>

            </div>


        </React.Fragment>
    )
}

export default Login;